<script setup lang="ts">
const { t } = useI18n();

const props = defineProps<{
  message?: string;
}>();

const messageText = computed(() => {
  return props.message === undefined ? t('Loading...') : props.message;
});
onMounted(() => {
  // console.log('messageText', messageText.value);
});
</script>

<template>
  <Teleport to="#teleports">
    <div class="absolute z-50 w-full h-full flex items-center justify-center  bg-gray-800/30 text-gray-950 pointer-events-auto">
      <div class="w-96 p-10 rounded-md bg-gray-100 flex flex-col gap-4 items-center justify-center">
        <div v-if="messageText">
          {{ messageText }}
        </div>
        <!--      LOADING ICON -->
        <svg
          class="w-10 h-10 text-blue-900"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 200 200"
        ><circle
          fill="currentColor"
          stroke="currentColor"
          stroke-width="15"
          r="15"
          cx="40"
          cy="100"
        ><animate
          attributeName="opacity"
          calcMode="spline"
          dur="2"
          values="1;0;1;"
          keySplines=".5 0 .5 1;.5 0 .5 1"
          repeatCount="indefinite"
          begin="-.4"
        /></circle><circle
          fill="currentColor"
          stroke="currentColor"
          stroke-width="15"
          r="15"
          cx="100"
          cy="100"
        ><animate
          attributeName="opacity"
          calcMode="spline"
          dur="2"
          values="1;0;1;"
          keySplines=".5 0 .5 1;.5 0 .5 1"
          repeatCount="indefinite"
          begin="-.2"
        /></circle><circle
          fill="currentColor"
          stroke="currentColor"
          stroke-width="15"
          r="15"
          cx="160"
          cy="100"
        ><animate
          attributeName="opacity"
          calcMode="spline"
          dur="2"
          values="1;0;1;"
          keySplines=".5 0 .5 1;.5 0 .5 1"
          repeatCount="indefinite"
          begin="0"
        /></circle></svg>
      </div>
    </div>
  </Teleport>
</template>

<style scoped>

</style>
